module.exports = __webpack_public_path__ + "static/media/BIFI-QUICK.681a82c5.png";